import { RootState } from '~/store';

export const getWebsiteReducer = (state: RootState) => state.websiteReducer;
